import React from "react";
// another components
import { InformacionPostulacionSubsanar } from "./InformationPostulacionSubsanar";
import { ParticipantesPostulacion } from "./ParticipantesPostulacion";
// styled components
import { Modal, Button, Tabs } from "antd";
// models
import { PostulacionModel } from "../../../../models/PostulacionesModel/postulacion.model";

interface IProps {
  modal: boolean;
  AceptarModal: any;
  postulacion: PostulacionModel;
  setPostulacion: any;
  allpostulaciones: Array<PostulacionModel>;
  setAllPostulaciones: any;
  descargarArchivo: any;
  lineasConvocatoria: any;
  CancelarModal: any;
  isBeps?: boolean;
  soloSubsanables?: boolean;
}

export const ModalVerPropuesta: React.FC<IProps> = (props: IProps) => {
  const tituloModal = props.soloSubsanables
    ? `Subsanar documentos: ${props.postulacion?.nombre_propuesta || ""}${props.postulacion?.radicado ? ` (${props.postulacion.radicado})` : ""}`
    : `${props.postulacion?.nombre_propuesta || ""}`;

  return (
      <Modal
        title={tituloModal}
        style={{ top: 20 }}
        visible={props.modal}
        onCancel={props.CancelarModal}
        closeIcon="X"
        width={typeof window !== "undefined" && window.innerWidth < 768 ? "96%" : Math.min(window.innerWidth * 0.85, 1100)}
        footer={[
          <Button key="b_cancelar_modalverprosub" className="button-gray-ghost" onClick={props.CancelarModal}>
            CERRAR
          </Button>,
          <Button key="b_aceptar_modalverprosub" className="button-azul-radius" onClick={props.AceptarModal}>
            ACEPTAR
          </Button>,
        ]}
        bodyStyle={{
          padding: props.soloSubsanables ? "12px 16px" : 0,
        }}
        maskStyle={{
          backgroundColor: "rgba(31,174,239,0.8)",
          borderRadius: "6px",
        }}
      >
        {props.soloSubsanables ? (
          <div className="height-100 width-100 font-size-14px font-family-Montserrat-Regular">
            <InformacionPostulacionSubsanar
              postulacion={props.postulacion}
              setPostulacion={props.setPostulacion}
              allPostulaciones={props.allpostulaciones}
              setAllPostulaciones={props.setAllPostulaciones}
              descargarArchivo={props.descargarArchivo}
              isBeps={props.isBeps}
              lineasConvocatoria={props.lineasConvocatoria}
              soloSubsanables={true}
            />
          </div>
        ) : (
          <Tabs defaultActiveKey="1" className="height-100 width-100 tabs-modal-postulaciones">
            <Tabs.TabPane tab="Información" key="1" className="height-100 font-size-14px font-family-Montserrat-Regular">
              <InformacionPostulacionSubsanar
                  postulacion={props.postulacion}
                  setPostulacion={props.setPostulacion}
                  allPostulaciones={props.allpostulaciones}
                  setAllPostulaciones={props.setAllPostulaciones}
                  descargarArchivo={props.descargarArchivo}
                  isBeps={props.isBeps}
                  lineasConvocatoria={props.lineasConvocatoria}
                />
            </Tabs.TabPane>
            <Tabs.TabPane
              tab="Participantes"
              key="2"
              className="height-100 font-size-14px font-family-Montserrat-Regular"
            >
              <ParticipantesPostulacion postulacion={props.postulacion} />
            </Tabs.TabPane>
          </Tabs>
        )}
      </Modal>
  );
};
